// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__1jmL4","sm":"Divider_sm__1dSAE","lg":"Divider_lg__31yfR"};